import { DEFAULT_AXIS_COLOR } from "../../../../lib/application/stats/shared/core/colors/colors";
import { MainChartDimensions } from "../../../../lib/application/stats/shared/core/definitions";

interface Props {
  horizontalAxisOffset?: number;
  dims: MainChartDimensions;
  customStrokeColor?: string | null;
  children?: JSX.Element;
}
export function AxisLineBottom(props: Props) {
  const { dims, customStrokeColor, children } = props;
  if (customStrokeColor === null) {
    return null;
  }
  const axisOffset = props.horizontalAxisOffset ?? 0;
  const y = dims.boundedHeight - axisOffset;
  return (
    <g transform={`translate(${dims.marginLeft}, ${dims.marginTop})`}>
      <line
        x1="0"
        y1={y}
        x2={dims.boundedWidth}
        y2={y}
        stroke={customStrokeColor ?? DEFAULT_AXIS_COLOR}
        strokeWidth="1"
        fill="none"
        shapeRendering="crispEdges"
      />
      {children}
    </g>
  );
}
